module.exports = __webpack_public_path__ + "img/condition.d70add64.svg";